/* eslint-disable import/no-cycle */
import { IAmazonCompositeKeywordData } from '../../../../constants/research';
import { ProductsEvaluatorService } from '../products-evaluator.service';


export class RelevanceScoreEvaluatorService {

	constructor(
		private productsEvaluatorService: ProductsEvaluatorService
	) {}

	/**------------------------------------------------------
	 * Relevances
	 */
	clothingRelevance(keywordData: IAmazonCompositeKeywordData): number {
		return this.productsEvaluatorService.productDistribution(keywordData).clothing;
	}

	bookRelevance(keywordData: IAmazonCompositeKeywordData): number {
		return this.productsEvaluatorService.productDistribution(keywordData).book;
	}
}
